/* ==========================================================================
   Lumen license verifier.
   One licence unlocks everything — there are no tiers, so the only question is
   whether this store is licensed. Sets html[data-lumen-pro]:
     active   -> premium features render for shoppers
     inactive -> premium features are hidden
     editor   -> theme editor: always render, so they can be configured
   Fires document 'lumen:license' { active, updates }.
   Fail-open on a network/TLS error so a paying store is never broken by a blip
   (and says so in the editor, so that is never mistaken for success).
   ========================================================================== */
(function () {
  var L = window.LumenLicense;
  if (!L) return;
  var root = document.documentElement;
  var CACHE = 'lumen_lic_v3';

  function readCache() { try { return JSON.parse(localStorage.getItem(CACHE) || 'null'); } catch (e) { return null; } }
  function writeCache(active, token, updates) {
    try {
      localStorage.setItem(CACHE, JSON.stringify({
        key: L.key, active: active, token: token || null, updates: updates || null,
        exp: Date.now() + (active ? 24 : 2) * 3600 * 1000  // re-check daily when active, sooner when not
      }));
    } catch (e) {}
  }

  function apply(active, updates) {
    if (L.designMode) {
      root.setAttribute('data-lumen-pro', 'editor');
      root.setAttribute('data-lumen-pro-status', active ? 'active' : 'inactive');
    } else {
      root.setAttribute('data-lumen-pro', active ? 'active' : 'inactive');
    }
    // Editor-only "update available" hint.
    if (L.designMode && updates && updates.update_available) {
      root.setAttribute('data-lumen-update', updates.latest || '1');
    }
    document.querySelectorAll('[data-lumen-pro-ribbon]').forEach(function (el) {
      el.setAttribute('data-status', active ? 'active' : 'inactive');
    });
    document.dispatchEvent(new CustomEvent('lumen:license', { detail: { active: active, updates: updates || null } }));
  }

  /* Editor status chip. Theme settings can't run code or show a result, so this
     is where the merchant learns whether their key worked — and why not. */
  var REASONS = {
    no_key: 'No licence key entered',
    invalid_key: 'That key isn’t valid',
    malformed: 'That key isn’t valid',
    bad_signature: 'That key isn’t valid',
    expired: 'This licence has expired',
    store_limit_reached: 'This key is already in use on another store',
    store_not_activated: 'This store isn’t activated on that licence',
    license_revoked: 'This licence has been revoked',
    license_suspended: 'This licence is suspended',
    unreachable: 'Couldn’t reach the licence server — showing everything for now',
    http_404: 'Licence server not found at that address (404) — check the endpoint',
    http_500: 'The licence server returned an error (500)'
  };
  function reasonText(d) {
    var r = d && d.reason;
    if (r && REASONS[r]) return REASONS[r];
    if (r && r.indexOf('http_') === 0) return 'Licence server returned ' + r.slice(5) + ' — check the endpoint';
    return 'Licence not active';
  }
  function status(state, text) {
    var el = document.querySelector('[data-lumen-status]');
    if (!el) return;
    el.setAttribute('data-state', state);
    var t = el.querySelector('[data-lumen-status-text]');
    if (t) t.textContent = text;
  }
  function describe(d, active) {
    if (!active) return reasonText(d);
    var plan = d && d.plan ? d.plan.charAt(0).toUpperCase() + d.plan.slice(1) : 'Pro';
    var exp = d && d.expires ? ' · renews ' + String(d.expires).slice(0, 10) : '';
    return 'Licence active — ' + plan + exp;
  }

  var cache = readCache();
  var fresh = cache && cache.key === L.key && cache.exp > Date.now();
  if (fresh) {
    apply(cache.active, cache.updates);
    if (cache.exp - Date.now() > 6 * 3600 * 1000) return; // still comfortably fresh
  }

  var url = L.endpoint + (L.endpoint.indexOf('?') < 0 ? '?' : '&') +
    'shop=' + encodeURIComponent(L.shop) + '&key=' + encodeURIComponent(L.key) +
    '&version=' + encodeURIComponent(L.version || '') + '&environment=' + encodeURIComponent(L.environment || 'production');

  fetch(url, { method: 'GET', headers: { 'Accept': 'application/json' }, credentials: 'omit' })
    .then(function (r) { return r.ok ? r.json() : { active: false, reason: 'http_' + r.status }; })
    .then(function (d) {
      var active = !!(d && d.active);
      apply(active, d && d.updates);
      writeCache(active, d && d.token, d && d.updates);
      if (L.designMode) status(active ? 'active' : 'inactive', describe(d, active));
    })
    .catch(function () {
      // Endpoint unreachable (offline, DNS, untrusted certificate): keep any
      // cached verdict, otherwise fail open rather than break a paying store.
      if (!fresh) apply(true, null);
      if (L.designMode) status('warn', REASONS.unreachable);
    });
})();
